import template from './menu.html';
import controller from './menu.controller';

const menuComponent = {
  restrict: 'E',
  template,
  controller
};

export default menuComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/menu/menu.component.js
 **/